/**
 * Detects browser, OS, and additional system information
 * @returns {Object} System information object
 */
export function detectBrowserOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Browser detection
  let browser = 'Unknown'
  if (userAgent.indexOf('Firefox') > -1) {
    browser = 'Firefox'
  } else if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1 && userAgent.indexOf('OPR') === -1) {
    browser = 'Chrome'
  } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    browser = 'Safari'
  } else if (userAgent.indexOf('Edg') > -1) {
    browser = 'Edge'
  } else if (userAgent.indexOf('OPR') > -1) {
    browser = 'Opera'
  } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) {
    browser = 'Internet Explorer'
  }

  // OS detection
  let os = 'Unknown'
  if (userAgent.indexOf('Win') > -1) {
    os = 'Windows'
  } else if (userAgent.indexOf('Mac') > -1) {
    os = 'macOS'
  } else if (userAgent.indexOf('Linux') > -1) {
    os = 'Linux'
  } else if (userAgent.indexOf('Android') > -1) {
    os = 'Android'
  } else if (userAgent.indexOf('iOS') > -1 || /iPad|iPhone|iPod/.test(userAgent)) {
    os = 'iOS'
  }

  // Screen Resolution
  const screenResolution = `${screen.width} x ${screen.height}`

  // Viewport Size
  const viewportSize = `${window.innerWidth} x ${window.innerHeight}`

  // Device Type
  let deviceType = 'Desktop'
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
  const isTablet = /iPad|Android/i.test(userAgent) && !/Mobile/i.test(userAgent)
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  if (isMobile) {
    deviceType = 'Mobile'
  } else if (isTablet) {
    deviceType = 'Tablet'
  }

  // Browser Zoom Level (approximate)
  // Note: devicePixelRatio is for display density (Retina = 2x), not browser zoom
  // Browser zoom detection is tricky and not always accurate
  // This is an approximation based on the ratio of outerWidth to screen width
  const zoomLevel = Math.round(
    ((window.outerWidth / screen.width) * 100) || 
    ((window.devicePixelRatio || 1) * 100)
  )

  // Timezone
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return {
    browser,
    os,
    screenResolution,
    viewportSize,
    deviceType,
    hasTouch,
    zoomLevel,
    timezone,
  }
}

